import React, { useCallback, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Modal, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

const CancelReservationSpecifyReasonModal = ({
  isOpen,
  onCancel,
  onSubmit,
}) => {
  const [reason, setReason] = useState("");
  const onConfirmClick = useCallback(() => {
    onSubmit(reason);
  }, [onSubmit, reason]);
  const { t } = useTranslation();

  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isOpen}
    >
      <Box
        sx={{
          background: "white",
          width: "480px",
          maxWidth: "95vw",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Stack sx={{ flexDirection: "column", direction: "column" }}>
          <Typography color={"#323130"} variant="fontBoldSize20">
            {t("components.cancelReservationSpecifyReasonModal.text01")}
          </Typography>

          <Typography color={"#605E5C"} variant="fontBoldSize18">
            {t("components.cancelReservationSpecifyReasonModal.text02")}
          </Typography>

          <TextField
            sx={{ mt: 2 }}
            placeholder="Not Travelling"
            multiline
            fullWidth
            maxRows={3}
            minRows={3}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ style: { resize: "both" } }}
          />

          <Box mt={2} display={"flex"} justifyContent={"space-around"}>
            <LoadingButton
              size="small"
              sx={{ width: "150px", height: "40px" }}
              loading={false}
              color="primary"
              onClick={onConfirmClick}
              variant="contained"
            >
              {t("commonLabels.text18")}
            </LoadingButton>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};

CancelReservationSpecifyReasonModal.propTypes = {};

export default React.memo(CancelReservationSpecifyReasonModal);
